<template>
  <div >
    <h3 class="extend" :id="title" ref="tocPos">
    <span class="pkg">
      <div style="float: left;"
	   onMouseOver="this.style.textDecoration = 'underline'"
	   onMouseOut="this.style.textDecoration = ''"
	   @click="tocBoxShow"
	   >{{ title }}
	<template v-if="'ja'==$i18n.locale">
          <md-tooltip md-direction="right">クリックするとタイトル一覧を表示します</md-tooltip>
	</template>
      </div>
      <div v-if="$store.state.enableOptionInfoLink" style="float: left; padding-left: 30px; text-align: left; font-size:small;"><a href="#" class="link-info" style="color:#3673ac;" @click="toOptionInfo">価格・スペック情報確認</a></div>
    </span>
    </h3>
    <div :style="borderStyle">
    <template v-for="c,index in children">
      <simple-element v-if="c.nodeName.toLowerCase() != 'name'" :el="c"></simple-element>
      <!--
      <template v-if="elementNode(c)">
	<simple-element v-if="c.nodeName.toLowerCase() != 'name'" :el="c"></simple-element>
      </template>
      <template v-else >  なぜかこれを入れないとトップのテキストノードが表示されない 
	{{ c.textContent }}
      </template> -->
    </template>
    </div>
  </div>
</template>
<script>
var $ = require('jquery')

import SimpleEl from '@/components/SimpleElement'

export default {
    props: ['el'],
    data() {
	return {
	    children: [],
	    number: 0 // 何番目のselectinoなのかを保持
	}
    },
    computed: {
	title: function() {
	    return $(this.$props.el).find("name").text()
	},
	borderStyle: function() {
	    if(this.title in this.$store.state.errorSection)
		 return "border: solid 1px red;"
	    else return ""
	}
    },
    methods: {
	elementNode(c) {
	    //console.log(c)
	    return (Node.ELEMENT_NODE == c.nodeType)
	},
	tocBoxShow() {
	    // console.log(this.title)
	    // console.log(this.$store.state.section)
	    const el = this.$refs['tocPos']
	    //const el = $('#'+this.title)[0]
	    const bounds = el.getBoundingClientRect();
	    const tocBoxStyle = $('#toc')[0].style;
	    const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
	    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
	    tocBoxStyle.left = ""+ (scrollLeft + bounds.left + 10) +"px";
	    tocBoxStyle.top = "" + (scrollTop + bounds.bottom + 2) + "px" ;
	    //tocBoxStyle.display = "block";
	    $('#toc').fadeIn(300)
	},
	toOptionInfo() {
	    console.log(this.number)
	    window.open("../../ToOptionInfo.action?target="+this.number,
			"_blank",
			"width=800,height=500,resizable=yes,scrollbars=yes")
	}
    },
    components: {
	'simple-element': SimpleEl
    },
    beforeMount() {
	// console.log(this.el.children)
	// for IE ... IEだとjQueryで処理しないと動かない...
	//$(this.el).children().each((index,ch) => {
	//    this.children.push(ch)
	//})
	// テキストノードも入っている...
	let ch = this.el.childNodes
	for(let i=0; i<ch.length; i++ ) {
	    //console.log(ch[i])
	    this.children.push(ch[i])
	}

	this.$store.commit('addSection',this.title)
	this.number = this.$store.state.section.length -1
    }
}
</script>



// WEBPACK FOOTER //
// Selection.vue?5c28f915